/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_AvizoInputs */

const cs_enum_avizo = /** @type {(inputs: Enum_AvizoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avízo`)
};

const en_enum_avizo = /** @type {(inputs: Enum_AvizoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avízo`)
};

/**
* | output |
* | --- |
* | "Avízo" |
*
* @param {Enum_AvizoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_avizo = /** @type {((inputs?: Enum_AvizoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_AvizoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_avizo(inputs)
	return cs_enum_avizo(inputs)
});